import { connect } from "react-redux";

import { fillMultiline } from "../../../Engine/ActionCreators/AllActionCreators";
import { removeUnitTableWidth, setUnitTableWidth } from "../../../Engine/ActionCreators/UnitTableActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withUnitLayoutingContext } from "../../FormParts/Unit/Internals/UnitBorderContext/UnitLayoutingContext";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { areArraysEqual } from "../../../../../Common/ArrayUtils";

import { StickyTableWrapper } from "./StickyTableWrapper";

interface StickyTableContainerProps {
    columnWidth: number[] | EvaluableProp<number[]>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: StickyTableContainerProps) => ({
    columnWidth: Array.isArray(ownProps.columnWidth)
        ? ownProps.columnWidth
        : ownProps.processEvaluableProp(state, ownProps.columnWidth),
    panelState: state.formVisualState.panelState,
    isWidePanel: state.formVisualState.isWidePanel,
});

const mapDispatchToProps = {
    setUnitTableWidth: setUnitTableWidth,
    removeUnitTableWidth: removeUnitTableWidth,
    fillMultiline: fillMultiline,
};

export const StickyTableContainer = withResolvePaths(
    withViewModelSelect(
        withEvaluators(
            connect(mapStateToProps, mapDispatchToProps, null, {
                areStatePropsEqual: (next, prev) =>
                    areArraysEqual(next.columnWidth, prev.columnWidth) &&
                    next.panelState === prev.panelState &&
                    next.isWidePanel === prev.isWidePanel,
            })(withUnitLayoutingContext(StickyTableWrapper))
        )
    )
);
